<template>
  <div class="min-h-screen font-sans antialiased relative">
    <div class="relative">
      <div class="cover-gradient-2 sm:cover-gradient"></div>
      <BaseNavbar />
      <main class="text-neutral-800">
        <NuxtPage v-slot="slot">
          <KeepAlive :max="10">
            <component
              v-if="slot.route.meta.keepalive"
              :is="slot.Page || slot.Component"
              :key="slot.route.name || slot.route.path"
            />
          </KeepAlive>
          <component
            v-if="!slot.route.meta.keepalive"
            :is="slot.Page || slot.Component"
            :key="slot.route.fullPath"
          />
        </NuxtPage>
      </main>
      <BaseFooter2 />
    </div>

    <Teleport to="body" :disabled="!contactForm.show">
      <div v-if="contactForm.show" :style="contactFormStyle">
        <LazyAdvancedContactForm ref="formRef" v-if="contactForm.show" />
      </div>
    </Teleport>
    <GlobalCookieConsent />
    <LazyGlobalAdminCallPopup />
    <LazyGlobalPhoneActionOverlay v-if="phoneMenuOpen || phoneHistoryOpen" />
    <LazyGlobalPublicCallOverlay v-if="publicCallOpen" />
    <div id="outer"></div>
  </div>
</template>

<script>
export default {
  name: 'TourLayout',
}
</script>

<style>@import "~/assets/css/tour.css"; @import "~/assets/css/main.css";</style>
<style lang="scss">@import "~/assets/css/main.scss";</style>

<script setup>
import { computed, provide } from 'vue'

const user = useUser()
const contactForm = useContactForm()
const { menuOpen: phoneMenuOpen, historyOpen: phoneHistoryOpen } = usePhoneActions()
const { open: publicCallOpen } = usePublicCallActions()
const formRef = ref(null)

const openNoteForm = (id, data) => {
  contactForm.value.show = true
  setTimeout(() => {
    formRef.value.openNoteForm(id, data)
  }, 1000)
}

const contactFormStyle = computed(() => (
  !user.value || user.value.U_Admin !== 'on'
    ? 'height: 100vh; position: fixed; top: 0; left: 0; width: 100%; z-index: 80; background: #fffffff2; margin: 0;'
    : 'height: auto; position: fixed; bottom: 0; right: 0; z-index: 50; margin: 0;'
))

provide('openNoteForm', openNoteForm)
</script>
